import { Download } from "@mui/icons-material"
import { Button } from "@mui/material"

export default function Invoice({order}){

    return order?.paid && 
        <Button
            variant='outlined'
            href={order?.invoiceUrl}
            target='_blank'
            rel='noopener noreferrer'
            download
            startIcon={<Download/>}
        >
            Télécharger la facture
        </Button>
}